import aboutConfig from './about/aboutConfig';
import articleConfig from './article/articleConfig';
import blogConfig from './blog/blogConfig';
import homeConfig from './home/homeConfig';
import pageConfig from './page/pageConfig';
import providersConfig from './providers/providersConfig';
import pricingConfig from './pricing/pricingConfig';
import patientsConfig from './patients/patientsConfig';
import investConfig from './invest/investConfig';
import directoryConfig from './directory/directoryConfig';

const marketingConfig = [
  aboutConfig,
  articleConfig,
  blogConfig,
  homeConfig,
  pageConfig,
  providersConfig,
  pricingConfig,
  patientsConfig,
  directoryConfig
];

export default marketingConfig;
